import { TActions } from '../../types';
import { RESET_VISIBLE_VIOLATIONS, SET_VISIBLE_VIOLATIONS } from './actions';
import { defaultState } from './defaultState';
import { IVisibleViolationsState } from './types';

export function visibleViolations(
  state: IVisibleViolationsState = defaultState,
  action: TActions,
): IVisibleViolationsState {
  switch (action.type) {
    case SET_VISIBLE_VIOLATIONS: {
      return {
        ...state,
        ...action.payload,
        isValid: false,
      };
    }

    case RESET_VISIBLE_VIOLATIONS: {
      return {
        ...state,
        isValid: true,
        errors: [],
      };
    }

    default:
      return state;
  }
}
